<template>
  <div>
    <rabbey-toolbox
      :call-new="IsInRole(roles.GerenteRRHH) === true ? callNew : undefined"
      filterables
      @filter-search="onFilterSearch"
    >
      <!--Componente selector departamento-->
      <DepartmentSelector @selection-change="selectionChange" />
    </rabbey-toolbox>

    <rabbey-table2
      ref="rTable"
      index-url="/api/Postition/GetPositionByCompany"
      :paginate-from-api="false"
      :columns="columns"
      :actions="actions"
      :search="search"
      :default-params="getParams"
      @rtable-push-action="handleCommand"
    />

    <el-drawer
      :title="title"
      :visible.sync="drawer"
      positions="rtl"
      :before-close="handleBeforeClose"
    >
      <el-container>
        <el-main>
          <el-row>
            <el-col :span="24">
              <el-form
                ref="form"
                :model="form"
                label-position="left"
                size="mini"
                label-width="120px"
                :rules="rules"
                v-loading="loading_form"
              >
                <el-form-item label="Nombre" prop="Name">
                  <el-input
                    v-model="form.Name"
                    :disabled="formAction === 'view'"
                  ></el-input>
                </el-form-item>

                <!-- <el-form-item label="Nombre" prop="Name">
                  <el-input
                    v-model="form.isSupervisor"
                    :disabled="formAction === 'view'"
                  ></el-input>
                </el-form-item> -->

                <el-form-item label="Supervisor?" prop="IsSupervisor">
                  <el-col :span="15">
                    <el-select
                      v-model="form.IsSupervisor"
                      placeholder="Select Opction"
                      :disabled="formAction === 'view'"
                    >
                      <el-option label="SI" :value="true"></el-option>
                      <el-option label="NO" :value="false"></el-option>
                    </el-select>
                  </el-col>
                </el-form-item>

                <el-form-item label="Deparmento" prop="DeparmentId">
                  <el-select
                    v-model="form.DeparmentId"
                    placeholder="Select Deparmento"
                    filterable
                    :disabled="formAction === 'view'"
                  >
                    <el-option
                      v-for="dep in departamentos"
                      :key="dep.ID"
                      :value="dep.ID"
                      :label="dep.Name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label-width="0">
                  <el-button
                    type="primary"
                    @click="onSubmit(formAction)"
                    v-loading="drawerLoading"
                    v-if="formAction !== 'view'"
                    >{{ labelButton }}</el-button
                  >
                  <el-button @click="onCancel">Cancel</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>
  </div>
</template>
<script>
import { formatDate } from "@/utils";
import DepartmentSelector from "@/components/Company/DepartmentSelector.vue";

export default {
  name: "PositiosnList",
  components: {
    DepartmentSelector
  },
  data() {
    return {
      search: "",
      loading_form: false,
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      loading: false,
      departmentId: null,
      //directionId: null,
      productId: 0,
      serviceRequestTypeId: 0,
      technicalId: 0,
      items: [],
      drawer: false,
      title: "",
      labelButton: "Crear",
      drawerLoading: false,
      detail: {
        id: 0,
        clientCode: ""
      },
      formAction: "create",
      form: {
        Name: "",
        CompanySelected: "",
        IsSupervisor: false
      },
      departamentos: [],
      rules: {
        Name: [{ required: true, message: "Nombre es requerido" }],
        DeparmentId: [{ required: true, message: "Departamento es requerido" }],
        IsSupervisor: [{ required: true, message: "Campo  es requerido" }]
      },
      columns: [
        {
          fixed: true,
          prop: "ID",
          name: "NO",
          width: 80
        },
        {
          prop: "Name",
          name: "Nombre",
          width: 600
        },
        {
          //
          prop: "Deparmento.Name",
          name: "Deparmento",
          width: 600,
          formatter: (row) => row.Deparmento.Name
        },
        {
          prop: "CreatedAt",
          name: "Fecha",
          width: 210,
          formatter: (row) => {
            return formatDate(row.CreatedAt, "DD/MM/YYYY");
          }
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        }
      ]
    };
  },
  computed: {
    getParams() {
      return {
        companyId: this.currentCompany,
        departmentId: this.departmentId
        //directionId: this.directionId,
      };
    }
  },
  methods: {
    formatDate,
    onFilterSearch(s) {
      this.search = s;
    },
    callNew() {
      this.callForm("create");
    },
    getDeparmentos() {
      this.$http
        .get("/api/Deparments/all", {
          params: {
            companyId: this.currentCompany
          }
        })
        .then((resp) => {
          this.departamentos = resp.data;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getDataById(id) {
      const l = this.$loading({
        text: "Cargando datos"
      });
      this.$http
        .get(`/api/Postition/${id}`)
        .then((resp) => {
          this.form = resp.data;
          this.drawer = true;
        })
        .catch((err) => {
          this.drawer = false;
          this.$alert(err.message, err.name, {
            type: "error"
          });
        })
        .finally(() => {
          l.close();
        });
    },
    onSubmit(action) {
      // validar el form
      this.$refs.form.validate((valid) => {
        if (valid) {
          // Peticion de creacion
          if (action === "create") {
            this.loading_form = true;
            this.drawerLoading = true;
            this.$http
              .post("/api/Postition", {
                DeparmentId: this.form.DeparmentId,
                Name: this.form.Name,
                CompanySelected: this.currentCompany,
                isSupervisor: this.form.IsSupervisor
              })
              .then(() => {
                this.drawer = false;
                this.message({
                  type: "success",
                  message: "Creado"
                });
                this.columns();
              })
              .catch(() => {
                this.message.error("Erro!");
                this.loading_form = false;
              })
              .finally(() => {
                this.loading_form = false;
                this.drawerLoading = false;
                this.$refs.rTable.initialTable();
                this.form = {};
              });
          } else if (action === "edit") {
            this.loading_form = true;
            this.drawerLoading = true;
            this.$http
              .put(`/api/Postition/${this.form.Id}`, this.form)
              .then(() => {
                this.drawer = false;
                this.$message({
                  type: "success",
                  message: "Actualizado"
                });
              })
              .catch(() => {
                this.message.error("Erro!");
              })
              .finally(() => {
                this.loading_form = false;
                this.drawerLoading = false;
                this.drawer = false;
                this.drawerLoading = false;
                this.form = {};
                this.$refs.rTable.initialTable();
              });
          }
        } else {
          this.drawer = true;
          return false;
        }
      });
    },
    handleBeforeClose(done) {
      this.$refs.form.resetFields();
      done();
    },
    callForm(type) {
      if (type === "create") {
        this.form = {
          Name: "",
          CompanySelected: "",
          DireccionID: this.currentCompany,
          Direccion: "",
          DeparmentId: ""
        };
        this.title = `Crear Posicion`;
        this.formAction = "create";
        this.drawer = true;
      }
    },
    onCancel() {
      this.form = {};
      this.drawer = false;
      this.drawerLoading = false;
    },
    handleCommand(option) {
      const isValid = this.IsInRole(this.roles.GerenteRRHH);
      if (
        (option.command === "edit" && !isValid) ||
        (option.command === "view" && !isValid)
      ) {
        this.$message.warning("Lo sentimos usted no tiene acceso");
      } else {
        switch (option.command) {
          case "view": {
            this.title = `Ver - ${option.row.Name}`;
            this.formAction = "view";
            this.getDataById(option.row.ID);
            break;
          }
          case "edit": {
            this.title = `Editar - ${option.row.Name}`;
            this.labelButton = "Editar";
            this.formAction = "edit";
            this.getDataById(option.row.ID);
            break;
          }
          case "delete":
            this.$confirm("Segura/o que desea eliminar este registro ?").then(
              () => {
                this.$http
                  .post(
                    `/api/Postition/DeletePostition/${option.row.ID}`,
                    this.form
                  )
                  .then(() => {
                    this.$message({
                      type: "success",
                      message: "Actualizado"
                    });
                  });
                //   this.$message.success("Contacto eliminado");
                // })
                // .catch(() => {
                //   this.$message.info("Eliminacion cancelada");
              }
            );
            break;
          default:
            this.formAction = "create";
            break;
        }
      }
    },
    selectionChange(DepartmentID) {
      this.departmentId = DepartmentID;
      //console.log(this.departmentId)
    }
  },
  mounted() {
    // this.getData();
    this.getDeparmentos();
  }
};
</script>

<style>
.el-dropdown-link {
  cursor: pointer;
  color: #3c3c3c;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
